/**
 * localStorage-backed flags for first-visit tutorial + coachmark.
 *
 * Version bump triggers re-display so we can roll out new content without
 * code changes other than the constant. Keys live in localStorage because
 * a stale flag across devices is acceptable — server-side persistence is a
 * deliberate non-goal (see spec §Non-Goals).
 */
export const TUTORIAL_VERSION = 'v1';
export const COACHMARK_VERSION = 'v1';

const TUTORIAL_KEY = 'promo_tutorial_seen';
const COACHMARK_KEY = 'promo_coachmark_seen';

function safeStorage(): Storage | null {
  try {
    if (typeof localStorage === 'undefined') return null;
    return localStorage;
  } catch {
    return null;
  }
}

export function hasSeenTutorial(): boolean {
  return safeStorage()?.getItem(TUTORIAL_KEY) === TUTORIAL_VERSION;
}

export function markTutorialSeen(): void {
  safeStorage()?.setItem(TUTORIAL_KEY, TUTORIAL_VERSION);
}

export function hasSeenCoachmark(): boolean {
  return safeStorage()?.getItem(COACHMARK_KEY) === COACHMARK_VERSION;
}

export function markCoachmarkSeen(): void {
  safeStorage()?.setItem(COACHMARK_KEY, COACHMARK_VERSION);
}

/** Test-only helper — clears both flags. Do not call from app code. */
export function resetForTesting(): void {
  const s = safeStorage();
  if (!s) return;
  s.removeItem(TUTORIAL_KEY);
  s.removeItem(COACHMARK_KEY);
}
